export const getLocaleString = (date: Date, timeZone?: string) => {
  return date?.toLocaleString("ko-KR", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: timeZone ?? "Asia/Seoul" });
}

export const convertDatetime = (date: Date, timeZone?: string) => {
  if (isNaN(date.getTime())) {
    return "";
  }

  const formatter = new Intl.DateTimeFormat("ko-KR", {
    timeZone: timeZone ?? "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });

  const parts = formatter.formatToParts(date);
  const obj: Record<string, string> = {};
  for (const { type, value } of parts) {
    obj[type] = value;
  }

  // ISO8601 형태 (YYYY-MM-DDTHH:mm)
  return `${obj.year}-${obj.month}-${obj.day}T${obj.hour}:${obj.minute}`;
}

export const getDateWithoutSeconds = () => {
  const now = new Date();
  now.setSeconds(0, 0);
  return now;
}